import React from 'react'
import PropTypes from 'prop-types'
import { Button, Form, InputNumber, Slider, Switch } from 'antd'
import { SoundOutlined } from '@ant-design/icons'
import {
  DEFAULT_ALERT_TTS_SETTINGS,
  loadAlertTtsSettings,
  previewSurveillanceAlertSpeak
} from './surveillanceAlertTts'

/**
 * 告警语音设置表单（WrappedModal 注入 form）。
 * 字段：enabled / rate / pitch / volume / repeatNoBaby / repeatIntervalSec
 */
class SurveillanceAlertTtsSettingsForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    formKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  componentDidMount () {
    this.hydrateFromStorage()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.formKey !== this.props.formKey) {
      this.hydrateFromStorage()
    }
  }

  hydrateFromStorage = () => {
    const { form } = this.props
    if (!form || !form.current) return
    const settings = loadAlertTtsSettings()
    form.current.setFieldsValue({
      enabled: settings.enabled,
      rate: settings.rate,
      pitch: settings.pitch,
      volume: settings.volume,
      repeatNoBaby: settings.repeatNoBaby,
      repeatIntervalSec: settings.repeatIntervalSec
    })
  }

  handlePreview = () => {
    const { form } = this.props
    if (!form || !form.current) return
    const fields = form.current.getFieldsValue(true)
    previewSurveillanceAlertSpeak({
      rate: fields.rate,
      pitch: fields.pitch,
      volume: fields.volume
    })
  }

  render () {
    const { form, formKey } = this.props
    return (
      <Form
        key={formKey}
        ref={form}
        layout="vertical"
        initialValues={{ ...DEFAULT_ALERT_TTS_SETTINGS }}
      >
        <Form.Item name="enabled" label="告警语音" valuePropName="checked">
          <Switch checkedChildren="开" unCheckedChildren="关" />
        </Form.Item>
        <Form.Item name="rate" label="语速 (0.5～2)">
          <Slider min={0.5} max={2} step={0.1} />
        </Form.Item>
        <Form.Item name="pitch" label="音调 (0～2)">
          <Slider min={0} max={2} step={0.1} />
        </Form.Item>
        <Form.Item name="volume" label="音量 (0～1)">
          <Slider min={0} max={1} step={0.1} />
        </Form.Item>
        <Form.Item name="repeatNoBaby" label="无婴儿重复播报" valuePropName="checked">
          <Switch checkedChildren="开" unCheckedChildren="关" />
        </Form.Item>
        <Form.Item name="repeatIntervalSec" label="重复间隔（秒）">
          <InputNumber min={10} max={600} step={10} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="试听">
          <Button icon={<SoundOutlined />} onClick={this.handlePreview}>
            提醒铃 + 示例播报
          </Button>
        </Form.Item>
      </Form>
    )
  }
}

export default SurveillanceAlertTtsSettingsForm
